
// Ration calculator
/**
 *  @class
 *  @function RationCalculator
 */
if (!customElements.get('ration-calculator')) {
    customElements.define('ration-calculator', class RationCalculator extends HTMLElement {
        constructor() {
            super();

            // modal controls
            this.modalBg = this.parentElement.querySelector('.rc-modal__bg');
            this.modalClose = this.parentElement.querySelector('.rc-modal__close');

            this.modalBg.addEventListener('click', this.closeModal);
            this.modalClose.addEventListener('click', this.closeModal.bind(this));

            //Subscription plan control
            this.subPlanSwitch = this.parentElement.querySelector('.switch');
            this.subPlanSwitch.addEventListener('change', this.toggleSubPlan);

            //single-serving size 
            this.servingSize = parseFloat(this.dataset.singleServing);

            this.querySelector('select').addEventListener('change', (event) => this.calculate());

            // get all day cells
            this.dayCells = Array.from(this.querySelectorAll('[data-number-of-days]'));

            // get all cost per day cells
            this.costPerDayCells = Array.from(this.querySelectorAll('[data-cost-per-day]'));

            // get all cost per lowest size cells
            this.costPerLowest = Array.from(this.querySelectorAll('[data-cost-per-lowest]'));
            //If there are no variants to display in the calculator, hide all reference to the calculator
            //This could happen if HH haven't assigned the ration_calculator.variant_size metafield to variants that would otherwise show
            if (this.dayCells.length == 0) {
                this.parentElement.classList.add('hide');
                const rationCalcPopUpPrompt = document.querySelector('.product-info_ration-calc');
                if (rationCalcPopUpPrompt) {
                    rationCalcPopUpPrompt.classList.add('hide');
                }
            }
        }

        calculate() {
            var servingQuantity = parseFloat(this.querySelector('select').value);
            var portion = servingQuantity * this.servingSize;
            portion = Math.round((portion + Number.EPSILON) * 100) / 100;
            var unitPerDay = this.querySelector('[data-unit-per-day]');
            unitPerDay.classList.remove('is-hidden');
            unitPerDay.querySelector('span').innerHTML = `${portion}${this.dataset.unit}`;

            var format = window.theme.settings.money_with_currency_format;

            this.dayCells.forEach(cell => {
                var variantSize = parseFloat(cell.parentElement.dataset.variantSize);
                var numberOfDays = Math.floor(variantSize / (this.servingSize * servingQuantity));
                cell.innerHTML = numberOfDays;
            });

            this.costPerDayCells.forEach(cell => {
                var variantSize = parseFloat(cell.parentElement.dataset.variantSize);
                var numberOfDays = Math.floor(variantSize / (this.servingSize * servingQuantity));
                var price = parseFloat(cell.parentElement.dataset.variantPrice);
                var pricePerDay = price / numberOfDays;
                if (cell.dataset.discountPercentage) {
                    pricePerDay = pricePerDay * parseFloat(cell.dataset.discountPercentage);
                }
                pricePerDay = formatMoney(pricePerDay, format);
                cell.innerHTML = pricePerDay;
            });
        }

        closeModal() {
            if (this.parentElement.classList.contains('rc-modal--open')) {
                this.parentElement.classList.remove('rc-modal--open');
                document.querySelector('body').classList.remove('overflow-hidden');

            }
        }
        toggleSubPlan() {
            var calculator = document.querySelector('.ration-calculator');
            if (calculator.classList.contains('rc-plan--otp')) {
                calculator.classList.remove('rc-plan--otp');
                calculator.classList.add('rc-plan--sub');
            } else if (calculator.classList.contains('rc-plan--sub')) {
                calculator.classList.remove('rc-plan--sub');
                calculator.classList.add('rc-plan--otp');
            } else {
                console.error("Ration calculator isn't set to One Time Purchase or the Sub plan");
            }
        }

    });
}

if (!customElements.get('ration-calculator-opener')) {
    customElements.define('ration-calculator-opener', class RationCalculatorOpener extends HTMLElement {
        constructor() {
            super();

            this.addEventListener('click', this.openModal);
        }

        openModal() {
            var calculator = document.querySelector('.ration-calculator');
            calculator.classList.add('rc-modal--open');

            document.querySelector('body').classList.add('overflow-hidden');
        }
    });
}